/* eslint-disable */
import topology from './topology';
export default () => 'all systems go!';
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/client/js/system/index.js